import React from "react";
import classnames from "classnames";
import { connect } from "react-redux";
import * as actions from "../../actions/actions";
import IconView from "../nounproject-icon-view.jsx";
import { NO_PREMIUM_FEATURES, YES_DO_UPSELL } from "../../reducers/download";

class DownloadUpsellModal extends React.Component {
    constructor(props) {
        super(props);
        this.onConfirm = this.onConfirm.bind(this);
        this.onDismiss = this.onDismiss.bind(this);
    }

    onConfirm(evt) {
        this.props.dismissModal(YES_DO_UPSELL);
    }

    onDismiss(evt) {
        this.props.dismissModal(NO_PREMIUM_FEATURES);
    }

    render() {
        let classes = classnames(
            "download-upsell-modal container fluid-container"
        );
        return (
            <div className={classes}>
                <div className="row">
                    <div className="columns columns twelve">
                        <h1 className="modal-title">
                            You will lose your edits, are you sure?
                        </h1>
                        <p>
                            Editing icons requires you to purchase it as a Pro.
                            This will also give you a Royalty–free license so
                            you won’t have to give any credit.
                        </p>
                    </div>
                </div>
                <div className="row actions">
                    <div className="columns five">
                        <IconView
                            color="black"
                            withAttribution
                            isEditable
                            imgSize={121}
                            icon={this.props.icon}
                        />
                        <button
                            className="decline button gray"
                            onClick={this.onDismiss}
                        >
                            Yes, lose my edits
                        </button>
                    </div>
                    <div className="columns five">
                        <IconView
                            withAttribution={false}
                            isEditable
                            imgSize={121}
                            icon={this.props.icon}
                        />
                        <button
                            className="confirm button blue"
                            onClick={this.onConfirm}
                        >
                            Keep edits with Pro
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {};
}

export default connect(mapStateToProps, {
    downloadUpsell: actions.downloadUpsell,
    downloadNoPremiumFeatures: actions.downloadNoPremiumFeatures
})(DownloadUpsellModal);
